import { render, staticRenderFns } from "./ExpenditureRequestItemsStep.vue?vue&type=template&id=2c834820&scoped=true&"
import script from "./ExpenditureRequestItemsStep.vue?vue&type=script&lang=js&"
export * from "./ExpenditureRequestItemsStep.vue?vue&type=script&lang=js&"
import style0 from "./ExpenditureRequestItemsStep.vue?vue&type=style&index=0&id=2c834820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c834820",
  null
  
)

export default component.exports